import CadastroUsuarioLicitacao from '@/views/pages/commons/portal/licitacao/cadastroUsuarioLicitacao/CadastroUsuarioLicitacao.vue'
import ListagemProcessosLicitacao from '@/views/pages/commons/portal/licitacao/listagemProcessosLicitacao/ListagemProcessosLicitacao.vue'
import PaginaInternaLicitacao from '@/views/pages/commons/portal/licitacao/paginaInternaLicitacao/PaginaInternaLicitacao.vue'

export default [
    {
        path: '/portal/licitacao/cadastro',
        name: 'licitacaoCadastroUsuario',
        component: CadastroUsuarioLicitacao,
        meta: {
            page: {
                title: 'Portal Licitação',
                subtitle: 'Cadastro'
            },
        }
    },
    {
        path: '/portal/licitacao/listagem',
        name: 'licitacaoListagemProcessos',
        component: ListagemProcessosLicitacao,
        meta: {
            page: {
                title: 'Portal Licitação',
                subtitle: 'Listagem'
            },
        }
    },
    {
        path: '/portal/licitacao/detalhe/:id',
        name: 'paginaInternaLicitacaoProcesso',
        component: PaginaInternaLicitacao,
        meta: {
            page: {
                title: 'Portal Licitação',
                subtitle: 'Detalhes'
            },
        }
    },
]
